// React
import React, { Component } from "react";
import PropTypes from "prop-types";
// i18n
import { withNamespaces } from "react-i18next";

class Input extends Component {
  getInputState() {
    const {
      meta: { touched, valid, error },
      t
    } = this.props;
    const invalidInput = {
      hasError: true,
      style: {
        borderColor: `#A90329`
      }
    };
    const validInput = {
      hasError: false,
      style: {
        borderColor: `#7DC27D`
      }
    };
    const neutralInput = { hasError: false, style: {} };

    return touched
      ? valid
        ? { ...validInput }
        : {
            ...invalidInput,
            errorMessage:
              error === `required`
                ? t(`modules.localization.register.authenticated.error.invalidFields.required`)
                : error === `err`
                ? t(`modules.localization.register.authenticated.error.invalidFields.default`)
                : error ||
                  t(`modules.localization.register.authenticated.error.invalidFields.default`)
          }
      : neutralInput;
  }

  render() {
    const { iconClass, input, label, placeholder, style, toolTip, type } = this.props;
    const inputState = this.getInputState();

    return (
      <section style={{ width: `100%` }}>
        {label && (
          <label htmlFor={label} className="label">
            {label}
          </label>
        )}
        <label htmlFor={label} className="input">
          <i className={iconClass} />
          <input
            placeholder={placeholder}
            style={{ ...style, ...inputState.style }}
            type={type || `text`}
            {...input}
          />
          {toolTip && (
            <b className="tooltip tooltip-top-right">
              <i className="fa fa-user txt-color-teal" />
              {toolTip}
            </b>
          )}
          <em className="invalid" style={{ height: 30, minHeight: 30 }}>
            {inputState.hasError && inputState.errorMessage}
            &nbsp;
          </em>
        </label>
      </section>
    );
  }
}

Input.defaultProps = {
  placeholder: ``,
  type: `text`
};

Input.propTypes = {
  errorMessage: PropTypes.string,
  iconClass: PropTypes.string,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
    valid: PropTypes.bool
  }),
  placeholder: PropTypes.string,
  style: PropTypes.object,
  t: PropTypes.func.isRequired,
  toolTip: PropTypes.string,
  type: PropTypes.oneOf([`date`, `email`, `password`, `text`, `url`]),
  value: PropTypes.string
};

export default withNamespaces()(Input);
